export enum EmailEventTypeEnum {
  BOUNCE = 'BOUNCE',
  CLICK = 'CLICK',
  COMPLAINT = 'COMPLAINT', 
  SEND = 'SEND',
  DELIVERY = 'DELIVERY',
  OPEN = 'OPEN', 
  REJECT = 'REJECT',
}
